/*
 * @Description:
 * @Autor: yaoguorong
 * @Date: 2021-09-28 18:23:07
 * @LastEditors: yaoguorong
 * @LastEditTime: 2021-11-24 17:32:20
 */

import { RsNgCarouselComponent } from './src/components/rs-ng-carousel';
import { RsNgModalComponent } from './src/components/rs-ng-modal';
import { RsNgButtonLineComponent } from './src/components/rs-ng-button-line';
import { RsNgStepsComponent } from './src/components/rs-ng-steps';

const compositeCompList = [
  RsNgCarouselComponent,
  RsNgModalComponent,
  RsNgButtonLineComponent,
  RsNgStepsComponent
];

const compositeCompMatch = {
  'rs-ng-carousel': RsNgCarouselComponent,
  'rs-ng-modal': RsNgModalComponent,
  'rs-ng-button-line': RsNgButtonLineComponent,
  'rs-ng-steps': RsNgStepsComponent,
};

export { compositeCompList, compositeCompMatch };
